<section
  [formGroup]="stepForm"
  class="mbs-wizard_form">
  <ng-container *ngIf="(ability.can('read', 'Notification') || isProvider) && !isRDMode">
    <div
      class="mbs-form-group"
      [formGroup]="notificationForm"
      [attr.data-e2e]="elementsSelector.name.mainNotificationSwitch">
      <mbs-group-button
        class="w-100"
        customClasses="w-100">
        <mbs-button
          [type]="'secondary'"
          class="flex-basis-50"
          customClasses="w-100 justify-content-center"
          [active]="!notificationFormEnabled"
          (click)="notificationFormEnabled = false">
          {{ 'wizards:notification_company_label' | i18next }}
        </mbs-button>
        <mbs-button
          [type]="'secondary'"
          class="flex-basis-50"
          customClasses="w-100 justify-content-center"
          [active]="notificationFormEnabled"
          (click)="notificationFormEnabled = true">
          {{ 'wizards:notification_specify_label' | i18next }}
        </mbs-button>
      </mbs-group-button>
    </div>

    <p
      class="mb-3"
      [attr.data-e2e]="elementsSelector.name.mainInfoBlock">
      {{ (notificationForm.get('enabled').value ? 'wizards:notificationInfoCompany1' : 'wizards:notificationInfoGlobal1') | i18next }}
      <ng-container *ngIf="companyId$ | async as companyId; else noCompanyId">
        <a
          [routerLink]="[RoutingPath.ApCompanies, companyId]"
          [queryParams]="{ tab: isBackupNotificationsMode ? 'notificationSettingsBackupTab' : 'notificationSettingsRestoreTab' }"
          target="_blank">
          {{ 'shared:notifications.notifications' | i18next }}
        </a>
      </ng-container>
      <ng-template #noCompanyId>
        {{ 'shared:notifications.notifications' | i18next }}
      </ng-template>
      {{ (notificationForm.get('enabled').value ? 'wizards:notificationInfoCompany2' : 'wizards:notificationInfoGlobal2') | i18next }}
    </p>

    <mbs-form-group class="mb-0">
      <ng-container
        *ngIf="notificationForm.get('enabled').value"
        [ngTemplateOutlet]="notificationTemplate"
        [ngTemplateOutletContext]="{ $implicit: notificationForm, readOnly: false }">
      </ng-container>

      <ng-container
        *ngIf="!notificationForm.get('enabled').value"
        [ngTemplateOutlet]="notificationTemplate"
        [ngTemplateOutletContext]="{ $implicit: globalNotificationForm, readOnly: true }">
      </ng-container>

      <ng-template
        #notificationTemplate
        let-mainForm
        let-readOnly="readOnly">
        <ng-container [formGroup]="mainForm">
          <mbs-card
            [hasPadding]="false"
            customClasses="notification-card mb-3">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-success text-green text-xl pr-2 card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.success' | i18next }}</h4>
            </div>
            <hr class="m-0 divider" />
            <mbs-notifications-checkboxes
              prefixId="{{ prefixType }}-success"
              formControlName="success"
              [cardMode]="true"
              [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>

          <mbs-card
            [hasPadding]="false"
            customClasses="notification-card mb-3">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-OverdueSettings pr-2 text-warning text-xl card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.warning' | i18next }}</h4>
            </div>
            <hr class="m-0 divider" />
            <mbs-notifications-checkboxes
              prefixId="{{ prefixType }}-warning"
              formControlName="warning"
              [cardMode]="true"
              [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>

          <mbs-card
            [hasPadding]="false"
            customClasses="notification-card mb-3">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-failed pr-2 text-danger text-xl card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.failed' | i18next }}</h4>
            </div>
            <hr class="m-0 divider" />
            <mbs-notifications-checkboxes
              prefixId="{{ prefixType }}-failure"
              formControlName="failure"
              [addThresholdFailed]="isBackupNotificationsMode ? true : false"
              [cardMode]="true"
              [hideThresholdM365Tooltip]="true"
              [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>

          <mbs-card
            *ngIf="isBackupNotificationsMode"
            [hasPadding]="false"
            customClasses="notification-card">
            <div class="p-3 d-flex align-items-center">
              <span class="ico ico-ClockO pr-2 text-danger text-xl card-ico"></span>
              <h4 class="my-0">{{ 'shared:notifications.noSuccess' | i18next }}</h4>
            </div>
            <hr class="m-0 divider" />
            <mbs-notifications-checkboxes
              formControlName="noSuccess"
              [addThresholdNoSuccess]="true"
              prefixId="{{ prefixType }}-no-success"
              [cardMode]="true"
              [hideThresholdM365Tooltip]="true"
              [readOnly]="readOnly">
            </mbs-notifications-checkboxes>
          </mbs-card>
        </ng-container>
      </ng-template>
    </mbs-form-group>
  </ng-container>

  <mbs-form-group formGroupName="receiveNotificationOnCompleteGroup">
    <mbs-card
      [hasPadding]="false"
      customClasses="notification-card mt-3">
      <div class="p-3 form-row align-items-center justify-content-between">
        <div class="col-11">
          <span
            class="fw-bold d-block mw-100"
            container="body"
            [placement]="'top auto'"
            [ngbTooltip]="userNotificationTooltip">
            <mbs-text-ellipsis
              [placement]="'right-top right auto'"
              [tooltip]="('wizards:notification_email_label' | i18next) + ' ' + userName">
              {{ 'wizards:notification_email_label' | i18next }}{{ userName }}
            </mbs-text-ellipsis>
          </span>
          <ng-template #userNotificationTooltip>
            <div>
              <span>
                {{ 'wizards:notification_email_tooltip1' | i18next }}
              </span>
              <span class="fw-bold">
                {{ 'wizards:notification_email_tooltip2' | i18next }}
              </span>
              <span>
                {{ 'wizards:notification_email_tooltip3' | i18next }}
              </span>
            </div>
          </ng-template>
        </div>
        <div class="col-auto">
          <mbs-switcher
            formControlName="flag"
            (change)="flagChangeHandler($event)"
            [id]="'receiveNotificationOnCompleteGroup-add-flag-switcher'"></mbs-switcher>
        </div>
      </div>
      <hr class="m-0 divider" />
      <div class="d-flex p-3">
        <mbs-radio
          formControlName="case"
          name="receiveNotificationOnCompleteGroupAddCaseRadio"
          value="whenFails"
          class="radio_row"
          [label]="
            isRestore ? ('wizards:restore_notification_when_fails' | i18next) : ('wizards:notification_email_when_fails_label' | i18next)
          "
          [id]="'receiveNotificationOnCompleteGroup-add-flag-radio-1'"></mbs-radio>
        <mbs-radio
          formControlName="case"
          name="receiveNotificationOnCompleteGroupAddCaseRadio"
          value="allCases"
          class="radio_row pl-4"
          [label]="'wizards:all_cases_label' | i18next"
          [id]="'receiveNotificationOnCompleteGroup-add-flag-radio-2'"></mbs-radio>
      </div>
    </mbs-card>
  </mbs-form-group>
</section>
